import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { LanguageSwitcher } from './LanguageSwitcher';
import { navConfig } from './navConfig';
import './AppShell.css';

export function AppShell({ children }: { children: ReactNode }) {
  const { signOut } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="app-shell">
      <aside className="app-shell__sidebar">
        <div className="app-shell__logo">{t('common.appName')}</div>
        <nav className="app-shell__nav">
          {navConfig.map((section) => (
            <div key={section.sectionKey} className="app-shell__section">
              <div className="app-shell__section-label">{t(section.sectionKey)}</div>
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.end}
                  className={({ isActive }) =>
                    'app-shell__nav-link' + (isActive ? ' app-shell__nav-link--active' : '')
                  }
                >
                  {t(item.labelKey)}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
      </aside>
      <div className="app-shell__main">
        <header className="app-shell__header">
          <LanguageSwitcher />
          <button className="app-shell__signout" onClick={() => void signOut()}>
            {t('nav.signOut')}
          </button>
        </header>
        <main className="app-shell__content">{children}</main>
      </div>
    </div>
  );
}
